import React, { Component } from 'react';
import ErrorWrapper from '../../lib/error_wrapper';
import { BasicHeader } from '../../components/basic_header';
import { CustomStats } from '../../components/custom_stat';
import { COLORS } from '../theme';
import { Table, Button, Divider, message, Spin, Space, Tooltip } from 'antd';
import { GetAppOutlined } from '@material-ui/icons';
import { RESTExecutor, withDomains } from '../../lib/domain';
import { showErrorInNotification, copyStringToClipboard, formatMoney } from '../../lib/util';
import { PopUpForm } from '../../lib/ui/popupform';
import { Link } from 'react-router-dom';
import { TextTag } from '../../components/basic_items';
import DayDifferennceTag from '../../components/day_difference_tag';
const queryString = require('query-string');

class FetcherLogDetail extends Component {
  constructor(props) {
    super(props)

    this.log_id = props.match.params.log_id;
    this.state = {
      log_info: {},
      selected_data: {},
      re_run_modal: false,
      form_data: {},
      loading: true,
      filter_query: {}
    }


    this.detail_log = RESTExecutor.detail().config({
      label: 'fetcher_logs_detail'
    }).callbacks((success) => {
      this.setState({ loading: false, log_info: success.result });
      this.list_responses.forId(success.result.id).config({
        params: {
          ...this.state.filter_query
        }
      }).execute();
    }, (error) => {
      this.setState({ loading: false })
      showErrorInNotification(error)
    }).forId(this.log_id).connect(props.domains.fetcher);


    this.list_responses = RESTExecutor.detail().config({
      label: 'fetcher_logs_responses',
      params: {
        ...this.state.filter_query
      }
    }).callbacks((success) => { }).forId(this.log_id).connect(props.domains.fetcher);

    this.download_response = RESTExecutor.detail().config({
      label: 'download_responses'
    }).callbacks((success) => {
      window.open(success.result.url, '_blank');
    }, (error) => {
      showErrorInNotification(error)
    }).connect(props.domains.fetcher);

    this.re_run = RESTExecutor.post().config({
      label: 'rerun_responses'
    }).callbacks((success) => {
      message.success(success.result.message || "Running selector.");
      this.setState({
        selected_data: {},
        re_run_modal: false,
        form_data: {}
      })
    }, (error) => {
      showErrorInNotification(error)
    }).connect(props.domains.fetcher);
  }
  reRun = (data) => {

    this.re_run.forId(this.state.selected_data.id).execute(data);
    // Rerun for given responses
  }
  downloadData = (data) => {
    this.download_response.forId(data.id).execute()
  }

  render() {
    const { selected_data, loading, filter_query, log_info } = this.state;
    if (loading) {
      return <center><Spin /></center>
    }
    let re_run_resp = this.re_run.response();
    let detail_log_resp = this.detail_log.response();
    let list_responses_resp = this.list_responses.response();
    let list_responses_data = list_responses_resp.result || {};
    let rowsData = list_responses_data.rows || [];
    let rowsMeta = list_responses_resp.meta || {}

    const required_fields = [
      { filterable: true, index: 'selectors', mode: 'tags', name: "Selector", help_text: "Which selector to run for given file.", type: 'networkselect', url: `/fetcher-responses/${selected_data.id}/selectors` }
    ]
    return (
      <ErrorWrapper
        error={detail_log_resp}
        onReload={() => {
          this.log_id = this.props.match.params.log_id;
          this.detail_log.forId(this.log_id).execute()
        }}
      >
        <PopUpForm
          width="60%"
          key={`${selected_data.id}rerun`}
          title={"Selector to Rerun"}
          show_title_only
          forCreate={true}
          initialData={this.state.form_data}
          fields={required_fields}
          open={this.state.re_run_modal}
          networkState={re_run_resp}
          onClose={() => {
            console.log("closing upload form")
            this.setState({
              re_run_modal: false,
              selected_data: {},
              form_data: {}
            })
          }
          }
          onSubmit={(data) => {
            console.log("DATA", data);
            this.reRun(data);
          }}
        />
        <div>
          <BasicHeader title="Fetcher Logs"
            subtitle={log_info.repository_name}
          />

          <div className='default-card' style={{
            // margin: 0,
            marginTop: 30
          }}>


            <div style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              paddingTop: 16,
              paddingLeft: 20, paddingRight: 20,
              paddingBottom: 16,
              alignItems: 'center'
            }}>
              <div style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center'
              }}>
                <Space size={20}>
                  <div className='credit-circle'>{log_info.manual == true ? "M" : "A"}</div>
                  {log_info.message != null ?
                    <Tooltip title={<div className='log-text'>
                      {(log_info.message || "")}
                    </div>}
                      placement='bottomRight'
                      arrowPointAtCenter
                      autoAdjustOverflow
                      overlayClassName={log_info.message ? 'error-tooltip side-scroll' : ''}
                    >
                      <div onClick={() => {
                        copyStringToClipboard(log_info.message);
                        message.success("Copied")
                      }} className={`dot-indicator danger`}></div>
                    </Tooltip> :
                    <div className={`dot-indicator`}></div>
                  }
                  <div className='description-text'>Fetcher Plugin : {log_info.fetcher_id}</div>
                </Space>
              </div>

              <div style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center'
              }}>
                <Space size={20}>
                  <div className='description-text'>{log_info.executed_at}</div>
                  <DayDifferennceTag date={log_info.executed_at} />
                  <TextTag type={log_info.status == "Completed" ? "success" :
                    log_info.status == "Failed" ? 'danger' : 'warning'
                  } label={(log_info.status || "").toUpperCase()} />
                </Space>

              </div>

            </div>
          </div>
          <ErrorWrapper
            error={list_responses_resp}
            onReload={() => {
              this.list_responses.execute()
            }}
          >
            <div className='default-card' style={{
              // marginLeft: 0, marginRight: 0,
              marginTop: 20
            }}>
              <Table
                dataSource={rowsData}
                loading={list_responses_resp.fetching}
                className='main-table padder'
                size='small'
                pagination={{
                  simple: false,
                  size: 'small',
                  position: 'bottom',
                  onChange: (current, size) => {
                    this.props.history.push({
                      search: queryString.stringify({ ...this.state.filter_query, per_page: size, page: current })
                    })
                  },
                  defaultCurrent: 1,
                  current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
                  pageSize: (rowsMeta && rowsMeta.requested_count),
                  total: (rowsMeta && rowsMeta.total_count),
                  showTotal: (total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`
                }}
                columns={[
                  {
                    title: `RESPONSES (${rowsMeta.total_count || 0})`,
                    dataIndex: 'file_path',
                    key: 'file_path',
                    className: 'word-break',
                    render: (value, record) => {
                      return <Link style={{
                        display:'flex',
                        alignItems:'center'
                      }} to={`/activity/fetcher/responses/${record.fetcher_log_id}/${record.id}`}>
                        <div className={`dot-indicator ${record.error == true ? 'danger' : ''}`} style={{
                          marginRight: 8
                        }}></div>
                        <span>
                          {value}</span>
                      </Link>
                    }
                  },
                  {
                    title: "RESPONSE SIZE",
                    dataIndex: 'file_size',
                    key: 'file_size',
                    width: 120,
                    render: (response_size = 0) => {
                      return (response_size / 1024).toLocaleString() + " Kb"
                    }
                  },
                  {
                    title: "ACTIONS",
                    width: 200,
                    className: 'center-align',
                    render: (record) => {
                      return <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}>
                        <Button title="Rerun"
                          onClick={() => {
                            this.setState({
                              selected_data: record,
                              re_run_modal: true
                            })
                          }}
                          style={{
                            padding: 0
                          }} type='link'>Re-run</Button>
                        <Divider type='vertical' />
                        <GetAppOutlined
                          onClick={() => {
                            this.downloadData(record)
                          }}
                          titleAccess="Download File" className='basic-icon hand-cursor' />

                      </div>
                    }
                  }
                ]}
              />
            </div>
          </ErrorWrapper>
        </div>

      </ErrorWrapper>
    );
  }
  componentDidMount() {
    let new_filter_query = {};
    if (this.props.location && this.props.location.search) {
      const parsed = queryString.parse(this.props.location.search);
      new_filter_query = parsed;
    }
    this.setState({
      filter_query: {
        per_page: 100,
        page: 1,
        ...new_filter_query
      }
    }, () => {
      this.detail_log.execute()
    })
  }
  componentWillReceiveProps(nextProps) {
    var oldlog_id = this.props.match.params.log_id;
    var newlog_id = nextProps.match.params.log_id;




    if (oldlog_id !== newlog_id || (
      this.props.location && (this.props.location.search !== nextProps.location.search)
    )) {
      this.log_id = newlog_id;
      const parsed = queryString.parse(nextProps.location.search);
      this.setState({
        filter_query: {
          per_page: 100,
          page: 1,
          ...parsed
        },
      }, () => {
        if (oldlog_id !== newlog_id) {
          this.setState({
            loading: true
          }, () => {
            this.detail_log.forId(this.log_id).execute()
          })
        } else {
          this.list_responses.forId(this.log_id).config({
            params: {
              ...this.state.filter_query
            }
          }).execute()
        }
      })

    }
  }

}

export default withDomains(FetcherLogDetail, "fetcher");
